import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaProfessoresLayer from "../components/ListaProfessoresLayer";
import { useTranslation } from "../i18n/I18nContext";

const ListaProfessoresPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("professor.breadcrumb.list")} />
      <ListaProfessoresLayer />
    </MasterLayout>
  );
};

export default ListaProfessoresPage;
